import {createAction, props} from '@ngrx/store';


export class ZahlungsprotokollActions {

  /**
   * Lädt das Zahlungsprotokoll zu einem Zahlungslauf und öffnet anschließend den Dialog.
   */
  public static openZahlungsprotokoll = createAction(
    '[Zahlungsprotokoll] Open zahlungsprotokoll.',
    props<{
      inhaberId: string,
      zahlungslaufId: string,
    }>(),
  );

  public static loadZahlungsprotokollSuccess = createAction(
    '[Zahlungsprotokoll] Load zahlungsprotokoll success.',
    props<{
      zahlungslaufId: string,
      content: string,
      filename: string,
    }>(),
  );

  public static loadZahlungsprotokollFailure = createAction(
    '[Zahlungsprotokoll] Load zahlungsprotokoll failure.',
    props<{
      status?: number,
    }>(),
  );

  public static closeZahlungsprotokollDialog = createAction(
    '[Zahlungsprotokoll] Close dialog.',
  );
}
